import React from 'react';

function Awards () {
    return (  
  <div className="container mt-5">
    <div className="row">
        <div className="col-6 p-5">
<img src="/media/largestBroker.svg" alt="largest broker"/>        </div>
        <div className="col-6 p-5 mt-5">
<h1>Largest stock broker in India</h1>
<p className="mb-5">2+ mllion Zerodha clients contribute to over 15% of all retail order
    volumes in India aily by trading and investing in:
</p>
<div className="row">

<div className="col-6 ">
<ul>
     <li>
     <p>Future and Options</p>
     </li>
     <li>
     <p>Commodity derivatives</p>
     </li>
     <li>
     <p>Currency derivatives</p>
     </li>
     </ul>
</div>

<div className="col-6">
    <ul>
       <li>
        <p>Stoks &IPOs</p>
       </li>
       <li>
        <p>Direct mutual funds</p>
       </li>
       <li>
         <p>Bonds</p>
       </li>
    </ul>
</div>
</div>
<img src="/media/pressLogos.png" alt="press logos" style={{width:"95%"}}/>
        </div>
    </div>
  </div>
    );
}

export default  Awards;